export default __webpack_public_path__ + "static/media/left-arrow.dfe339ea.svg";